import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import MobileMenu from '../components/MobileMenu';
import Logo from '../components/Logo';
import useSEO from '../hooks/useSEO';
import ClientHelpContent from '../components/ClientHelpContent';

const HelpPage = () => {
  const navigate = useNavigate();

  // SEO optimization
  useSEO({
    title: 'Hjälp & Support - Your Therapist | AI-driven terapi 24/7',
    description: 'Få hjälp med Your Therapist. Vanliga frågor och svar om AI-terapi, säkerhet, priser och hur du kommer igång med mental hälsovård online.',
    keywords: 'hjälp, support, FAQ, vanliga frågor, AI-terapi hjälp, teknisk support, användarguide',
    image: 'https://www.yourtherapist.se/logo512.png',
    url: 'https://www.yourtherapist.se/help',
    type: 'website'
  });

  const handleBackToHome = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-white">
      <style jsx>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
        
        .font-inter {
          font-family: 'Inter', sans-serif;
        }
      `}</style>

      {/* Top Navigation Bar */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex justify-between items-center h-16">
            <Logo 
              size="large"
              onClick={handleBackToHome}
              textColor="text-gray-900"
              hoverTextColor="hover:text-pink-600"
            />
            
            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-6">
              <button
                onClick={handleBackToHome}
                className="flex items-center gap-2 px-4 py-2 text-gray-700 hover:text-pink-600 transition-colors font-medium"
              >
                <ArrowLeft className="w-4 h-4" />
                Tillbaka hem
              </button>
            </div>

            {/* Mobile Menu Button */}
            <div className="md:hidden">
              <MobileMenu />
            </div>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <section className="pt-24 pb-16 w-full bg-neutral-50">
        <div className="max-w-7xl mx-auto px-6">
          <ClientHelpContent />
        </div>
      </section>
    </div>
  );
};

export default HelpPage;
